import { MsalProvider as Provider } from '@azure/msal-react';
import type { PropsWithChildren } from 'react';

import { pca } from './config.ts';

export function MsalProvider({ children }: PropsWithChildren) {
  return <Provider instance={pca}>{children}</Provider>;
}
